import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, X } from 'lucide-react';
export function ContextMissingPiece() {
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  return;
}
function MissingItem({
  text
}: {
  text: string;
}) {
  return <div className="flex items-center gap-4 p-4 bg-black/50 rounded-lg border border-gray-800" data-id="element-539">
      <X className="w-5 h-5 text-red-500 flex-shrink-0" data-id="element-540" />
      <span className="text-gray-300" data-id="element-541">{text}</span>
    </div>;
}